/**
 * @param {AddressCreate} address
 * @returns {ApiAddressCreate}
 */
export const formatCreateAddress = (address) => ({
  description: address.description,
  neighborhood: address.neighborhood,
  zipcode: address.zipcode.replace('-', ''),
  cityId: address.cityId,
  street: address.street,
  streetNumber: address.streetNumber,
  complementary: address.streetDetails,
  addressType: address.addressType || null,
  isMain: address.isMain,
})

/**
 * @param {AddressUpdate} address
 * @returns {ApiAddressUpdate}
 */
export const formatUpdateAddress = (address) => ({
  id: address.id,
  description: address.description,
  neighborhood: address.neighborhood,
  zipcode: address.zipcode.replace('-', ''),
  cityId: address.cityId,
  street: address.street,
  streetNumber: address.streetNumber,
  complementary: address.streetDetails,
  addressType: address.addressType || null,
  isMain: address.isMain,
})

/**
 * @param {AddressUpdate} address
 * @returns {ApiAddressUpdate}
 */
export const formatAddAddress = (address) => ({
  description: address.description,
  neighborhood: address.neighborhood,
  zipcode: address.zipcode.replace('-', ''),
  cityId: address.cityId,
  street: address.street,
  streetNumber: address.streetNumber,
  complementary: address.streetDetails,
  addressType: address.addressType || null,
  isMain: address.isMain,
})

export default {
  formatCreateAddress,
  formatUpdateAddress,
  formatAddAddress,
}
